import { Description } from '../../../components/Description';
import { Headline } from '../../../components/Headline';
import { Playground } from '../../../components/playground/Playground';

export const Details = () => (
    <div>
        <Headline anchor='details'>Details</Headline>
        <Description>
            Use the native <code>&lt;details&gt;</code> element to reveal supplementary content without JavaScript. The
            UIKIT style provides an animated chevron and a CSS-only expand and collapse transition.
        </Description>
        <Playground example={detailsExample} />
    </div>
);

const detailsExample = (
    <div className='display-grid grid-cols-1 grid-cols-2-sm gap-20'>
        <details open>
            <summary>Vehicle requirements</summary>
            <div className='padding-bottom-15'>
                The vehicle must have a valid inspection, the required equipment, and sufficient battery charge.
            </div>
        </details>
        <details>
            <summary className='padding-bottom-5'>Delivery notes</summary>
            <div className='padding-bottom-15'>
                The receiving area is accessible Monday through Friday from 08:00 to 16:00.
            </div>
        </details>
    </div>
);
